import Navbar from './components/Navbar';
import Hero from './components/Hero';
import SmileGallery from './components/SmileGallery';
import AppointmentScheduler from './components/AppointmentScheduler';
import Testimonials from './components/Testimonials';
import CareTips from './components/CareTips';
import Footer from './components/Footer';

function App() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <Hero />
      <SmileGallery />
      <AppointmentScheduler />
      <Testimonials />
      <CareTips />
      <Footer />
    </div>
  );
}

export default App;
